// extracted by mini-css-extract-plugin
export default {"floatingMenu":"FloatingMenu_floatingMenu__Er35y","hidden":"FloatingMenu_hidden__zxxk6"};